import React, { useEffect, useState } from 'react'
import { useGetCurrentQuizListQuery } from '../../../API/StartQuizQApi';
import { quizModel } from '../../../Interfaces/quizModel';
import QuizView from './QuizView';
import { quizQuestionModel } from '../../../Interfaces/quizQuestionModel';
import Loader from '../../../Helper/Loader';
interface props{
    userId:string
}
function CurrentQuizPage({userId}:props) {
    
    const {data, isLoading} = useGetCurrentQuizListQuery(userId);
    const[loading, setLoading] =useState(false);
    const[getQuestionRes, setGetQuestionRes] = useState<quizQuestionModel[]>([]);
    const[getLevel, setGetLevel] = useState({
     itemQuestions:0,
     quizLevel :0,
    });
    useEffect(() =>{
        setLoading(true);
        if(data?.result != null){
            //console.log(data.result.quizQuestions);
            setGetQuestionRes(data.result.quizQuestions);
            setGetLevel(prev => ({
                ...prev,
                itemQuestions:data.result.itemQuestions,
                quizLevel:data.result.quizLevel
            }))
        }
        setLoading(false)
    },[data])
  return (
    <div>
        {getQuestionRes.length > 0 && <QuizView questions={getQuestionRes} userId={userId} getLevel={getLevel}/> }
        {loading && <Loader/>} 
    </div>
  )
}

export default CurrentQuizPage